import axios from 'axios';
import { useAppStore } from '@src/stores/app.js';

export function filteredParams(filter) {
    return Object.fromEntries(
        Object.entries(filter).filter(([_, v]) => v !== null && v !== '')
    );
}

export function filterAllowedFields(obj, allowedFields) {
    const result = {};

    for (const field of allowedFields) {
        const keys = field.split('.');
        let src = obj;
        let dest = result;

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];

            if (src == null || !(key in src)) break;

            if (i === keys.length - 1) {
                dest[key] = src[key];
            } else {
                dest[key] = dest[key] || {};
                dest = dest[key];
                src = src[key];
            }
        }
    }

    return result;
}

export function filterDisallowedFields(obj, disallowedFields) {
    const result = JSON.parse(JSON.stringify(obj)); // Deep copy to avoid mutating original

    for (const path of disallowedFields) {
        const keys = path.split('.');
        let current = result;

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];

            if (!(key in current)) break;

            if (i === keys.length - 1) {
                delete current[key];
            } else {
                current = current[key];
                if (typeof current !== 'object' || current === null) break;
            }
        }
    }

    return result;
}

export function handleError(error, context = 'operácii') {
    const response = error.response;
    return {
        success: false,
        status: response?.status,
        errors: response?.data?.errors || { general: [`Nastala chyba pri ${context}.`] },
    };
}

export async function performDelete(url) {
    const appStore = useAppStore();
    appStore.loading = true;

    try {
        const { data } = await axios.delete(url);
        return {
            success: true,
            response: data.response,
        };
    } catch (error) {
        return handleError(error, 'mazaní');
    } finally {
        appStore.loading = false;
    }
}

export async function fetchList(url, onSuccess, params = {}) {
    const appStore = useAppStore();
    appStore.loading = true;

    try {
        const { data } = await axios.get(url, {params});
        onSuccess(data);
    } finally {
        appStore.loading = false;
    }
}